// TENEZ Footer JavaScript

class TenezFooter {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // PAGE TOP 滚动到顶部功能
    const pageTopButton = document.querySelector('.tenez-footer__page-top');
    if (pageTopButton) {
      pageTopButton.addEventListener('click', this.scrollToTop.bind(this));
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

// 初始化
document.addEventListener('DOMContentLoaded', () => {
  new TenezFooter();
});